import User from "models/user";

function stringToColor(string: string) {
  let hash = 0;
  let i;

  /* eslint-disable no-bitwise */
  for (i = 0; i < string.length; i += 1) {
    hash = string.charCodeAt(i) + ((hash << 5) - hash);
  }

  let color = "#";

  for (i = 0; i < 3; i += 1) {
    const value = (hash >> (i * 8)) & 0xff;
    color += `00${value.toString(16)}`.substr(-2);
  }
  /* eslint-enable no-bitwise */

  return color;
}

export function stringAvatar(user: User | null | undefined) {
  const name = user?.username;

  return {
    sx: {
      bgcolor: name ? stringToColor(name) : "gray",
      width: 32,
      height: 32,
    },
    children: name ? name[0].toUpperCase() : null,
  };
}
